export const SET_ACTIVE_ROUTE = "SET_ACTIVE_ROUTE";
export const DOMAIN_SEARCH_RESET_CACHE = "DOMAIN_SEARCH_RESET_CACHE";
export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE";
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";
export const SET_SUGGESTED_PACKAGES = "SET_SUGGESTED_PACKAGES";
export const GET_PRODUCTS_LOADED = "GET_PRODUCTS_LOADED";
export const GET_SUGGESTED_PACKAGES_SUCCESS = "GET_SUGGESTED_PACKAGES_SUCCESS";
export const GET_SUGGESTED_PACKAGES_FAILURE = "GET_SUGGESTED_PACKAGES_FAILURE";
export const SELECT_NEW_PACKAGE = "SELECT_NEW_PACKAGE";
export const SET_ERROR = "SET_ERROR";
export const SET_VOUCHER_CODE = "SET_VOUCHER_CODE";
export const POST_VOUCHER_CODE_FAILURE = "POST_VOUCHER_CODE_FAILURE";
export const MODAL_OPEN = "MODAL_OPEN";
export const MODAL_CLOSE = "MODAL_CLOSE";
export const SET_INPUT_DIRTY = "SET_INPUT_DIRTY";
export const DOMAIN_BY_TYPE_REQUEST = "DOMAIN_BY_TYPE_REQUEST";
export const DOMAIN_BY_TYPE_SUCCESS = "DOMAIN_BY_TYPE_SUCCESS";
export const DOMAIN_BY_TYPE_FAILURE = "DOMAIN_BY_TYPE_FAILURE";

export const NEXT_PAGE_REQUEST = "NEXT_PAGE_REQUEST";
export const NEXT_PAGE_SUCCESS = "NEXT_PAGE_SUCCESS";
export const NEXT_PAGE_FAILURE = "NEXT_PAGE_FAILURE";

export const BUNDLE_SEARCH_REQUEST = "BUNDLE_SEARCH_REQUEST";
export const BUNDLE_SEARCH_SUCCESS = "BUNDLE_SEARCH_SUCCESS";
export const BUNDLE_SEARCH_FAILURE = "BUNDLE_SEARCH_FAILURE";

export const FILTERED_DOMAIN_RESULTS_LIMIT = 20;
export const ALL_DOMAIN_RESULTS_LIMIT = 20;

export const SET_CUSTOMER_INFORMATION = "SET_CUSTOMER_INFORMATION";
export const CLEAR_CUSTOMER_INFORMATION = "CLEAR_CUSTOMER_INFORMATION";
export const SET_ACTIVE_FORM = "SET_ACTIVE_FORM";
export const SET_IS_SAME = "SET_IS_SAME";
export const SET_TLDS_WITH_SEPARATE_PAGE_TERMS =
  "SET_TLDS_WITH_SEPARATE_PAGE_TERMS";
export const SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS =
  "SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS";

export const SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES =
  "SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES";

export const GET_DISCLAIMERS = "GET_DISCLAIMERS";

export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";

export const SET_CITIZENSHIP_COUNTRY_CODE = "SET_CITIZENSHIP_COUNTRY_CODE";
